import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useDataFetching from 'hooks/useDataFetching';
import { config } from 'variables/config';
import TabContent2 from '../TabContent2';
import LanguageSwitcher from 'components/LanguageSwitcher';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TabBar() {
  const { i18n } = useTranslation();
  const [value, setValue] = React.useState(0);
  const [loadingR, errorR, regionsP, fetchDataR] = useDataFetching(
    `${config.app.api_url}/regions`
  );
  const [regions, setRegions] = React.useState([]);

  // Mémoriser les régions triées pour éviter les re-rendus inutiles
  React.useEffect(() => {
    if (regionsP?.data) {
      setRegions([...regionsP.data].sort((a, b) => a.name.localeCompare(b.name)));
    }
  }, [regionsP]);

  // Préserver l'onglet actif lors du changement de langue
  React.useEffect(() => {
    // Réinitialiser l'onglet actif si nécessaire (par exemple, si le nombre de régions change)
    if (value > regions.length && regions.length > 0) {
      setValue(0);
    }
  }, [i18n.language, regions, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: 'white', borderRadius: '8px', boxShadow: 3 }}>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          aria-label="Request"
          indicatorColor="primary"
          sx={{ flexGrow: 1 }}
        >
          <Tab label={i18n.t('national')} {...a11yProps(0)} />
          {regions.map((item, index) => (
            <Tab
              key={item.id} // Utiliser item.id pour une clé stable
              label={item.name}
              {...a11yProps(index + 1)}
            />
          ))}
        </Tabs>
        <Box sx={{ ml: 2, mr: 13 }}>
          <LanguageSwitcher />
        </Box>
      </Box>

      <div>
        <CustomTabPanel value={value} index={0}>
          <TabContent2 id={null} />
        </CustomTabPanel>
        {regions.map((item, index) => (
          <CustomTabPanel key={item.id} value={value} index={index + 1}>
            <TabContent2 regionParams={item} regionId={item.id} />
          </CustomTabPanel>
        ))}
      </div>
    </div>
  );
}